export default "__VITE_ASSET__CqhmWxpS__"